import * as React from "react";
import { HBox, VBox } from "framework/structural_components/hbox_vbox";
import { LoadingSpinner } from "framework/controls/loading";
import { useCompetitionResultState, useCompetitionState, useEventState, useResultsActions } from "../store";
import { cls_box_text_box } from "style/box_text.css";
import { cls_bold, cls_colorCyan70, cls_colorGrey90, cls_cursor_pointer, cls_gap_form, cls_gap_half_rem, cls_h9, cls_p3b, cls_p4b, cls_p5r, cls_text_align_center, cls_wrap } from "style/index.css";
import { cls_bottom_border, cls_col_31, cls_header_links_container, cls_round_naming_SF, cls_summary } from "./view.css";
import { getCompetitionNamingResults } from "../entity";
import { Summary } from "./viewSummary";
import { CompetitorDetail } from "./viewCompetitor";
import { RoundDetail } from "./viewRound";
import { cls_button_nostyle } from "framework/controls/button.css";
import { useif } from "framework/state/types";
import { Link } from "framework/link/link";
import { cls_align_items_baseline, cls_justify_content_center } from "framework/structural_components/hbox_vbox.css";
import { UrlPathOfPublicSection } from "common/paths";
import { getSeriesTypeFromString } from "public_app/view/entity";
import { SeriesType } from "public_app/events/entity";
import { getDateTextTwoDates_DayMonthNameYear, getTimeText_HourMinute, isValidDate } from "framework/helpers";
import { Adjudicators } from "./viewAdjudicators";
export var DanceLabels = function (props) {
    return React.createElement(React.Fragment, null, props.dances.map(function (dance, i) { return React.createElement(HBox, { key: i, className: [cls_justify_content_center, cls_text_align_center, cls_col_31, cls_p5r] }, dance); }));
};
function getRoundNamingElem(val) {
    return React.createElement(HBox, { className: [cls_justify_content_center, cls_round_naming_SF] }, val);
}
export var showCompletedAtValue = function (val, series) {
    if (isValidDate(val)) {
        var limitDate = series === SeriesType.DanceForAll ? new Date('2023-09-01T23:59:59') : new Date('2024-08-25T23:59:59');
        if (val < limitDate) {
            return false;
        }
    }
    return true;
};
var Content = function (props) {
    var _a = useCompetitionResultState(), state = _a[0], actions = _a[1];
    var comp_state = useCompetitionState()[0];
    var comp = comp_state.entity;
    var event_state = useEventState()[0];
    var event = event_state.entity;
    React.useEffect(function () {
        actions.loadCompetitionIfNeeded(state.entity.competitionId);
    }, [state.entity.competitionId]);
    var entity = state.entity;
    var roundsWithCompetitors = state.roundsWithCompetitors;
    var roundToShow = null;
    var competitorToShow = null;
    var showSummary = false;
    if (state.roundDetailKey !== null) {
        roundToShow = state.roundsWithCompetitors.find(function (r) { return r.number == state.roundDetailKey; }) || null;
    }
    else if (state.competitorDetailId !== null && state.roundsWithCompetitors.length) {
        competitorToShow = state.allCompetitors.find(function (c) { return c.competitorId == state.competitorDetailId; }) || null;
    }
    else {
        showSummary = true;
    }
    var completedAt = state.entity.completedAt;
    var showCompletedAt = false;
    var completedAtValue = '';
    if (comp) {
        var series = getSeriesTypeFromString(comp.series);
        showCompletedAt = showCompletedAtValue(completedAt, series);
    }
    if (showCompletedAt) {
        completedAtValue = "SKON\u010CENO ".concat(getTimeText_HourMinute(completedAt));
        if (completedAtValue === 'SKONČENO ') {
            showCompletedAt = false;
        }
    }
    var competitionAdjudicatorsToShow = [];
    if (showSummary || competitorToShow !== null) {
        competitionAdjudicatorsToShow = state.allAdjudicators;
    }
    else if (roundToShow !== null) {
        competitionAdjudicatorsToShow = roundToShow.adjudicators;
    }
    return React.createElement(VBox, { className: cls_gap_half_rem },
        React.createElement(HBox, null,
            React.createElement(VBox, { className: [cls_box_text_box, cls_gap_half_rem] },
                React.createElement(HBox, { className: [cls_p5r, cls_colorCyan70] },
                    React.createElement(Link, { url: "".concat(UrlPathOfPublicSection, "/vysledky_soutezi"), className: "".concat(cls_button_nostyle, " ").concat(cls_cursor_pointer) }, "Zpět na seznam soutěžních akcí")),
                event != null && React.createElement(HBox, { className: cls_p3b }, "".concat(event.eventTitle, " \u2014 ").concat(event.location, " \u2014 ").concat(getDateTextTwoDates_DayMonthNameYear(event.dateFrom, event.dateTo))),
                React.createElement(HBox, { className: [cls_p4b, cls_gap_form, cls_align_items_baseline] },
                    getCompetitionNamingResults(comp),
                    showCompletedAt && React.createElement(HBox, { className: [cls_h9, cls_colorGrey90] }, completedAtValue)),
                React.createElement(HBox, { className: [cls_header_links_container, cls_colorCyan70, cls_p5r, cls_bottom_border, cls_wrap] },
                    React.createElement(HBox, null,
                        React.createElement(Link, { className: [cls_cursor_pointer, useif(state.roundDetailKey == null && state.competitorDetailId == null, cls_bold)], url: "".concat(UrlPathOfPublicSection, "/vysledky_soutezi/event/").concat(props.eventId, "/competition/").concat(props.compId) },
                            React.createElement(HBox, { className: [cls_justify_content_center, cls_summary] }, "Výsledková listina"))),
                    roundsWithCompetitors.filter(function (r) { return true; }).reverse().map(function (r, ri) { return React.createElement(HBox, { key: r.round },
                        React.createElement(Link, { className: [cls_cursor_pointer, useif(r.number == state.roundDetailKey, cls_bold)], url: "".concat(UrlPathOfPublicSection, "/vysledky_soutezi/event/").concat(props.eventId, "/competition/").concat(props.compId, "/round/").concat(r.number) }, getRoundNamingElem(r.round))); })),
                showSummary && React.createElement(Summary, { roundsWithCompetitors: roundsWithCompetitors, eventId: props.eventId, compId: props.compId, allCompetitors: state.allCompetitors }),
                roundToShow !== null && React.createElement(RoundDetail, { compId: entity.competitionId, roundWithCompetitors: roundToShow, numberOfAdjudicators: roundToShow.adjudicators.length, eventId: props.eventId }),
                competitorToShow !== null && React.createElement(CompetitorDetail, { competitorResult: competitorToShow, roundsWithCompetitors: roundsWithCompetitors, numberOfAdjudicators: entity.officials.filter(function (o) { return o.type === "Adj"; }).length, compId: props.compId, dances: state.dances, eventId: props.eventId }))),
        comp !== null && React.createElement(Adjudicators, { adjudicators: competitionAdjudicatorsToShow, varyingAdjudicators: state.varyingAdjudicators }));
};
var View = function (props) {
    var _a = useCompetitionResultState()[0], loadingTooLong = _a.loadingTooLong, loading = _a.loading, loadFailure = _a.loadFailure, entity = _a.entity;
    var actions = useResultsActions();
    var eventId = props.eventId;
    var compId = props.compId;
    var roundNumber = props.roundNumber || null;
    var competitorId = props.competitorId || null;
    React.useEffect(function () {
        if (roundNumber === null && competitorId === null) {
            actions.setShowSummary();
        }
        else if (roundNumber !== null) {
            actions.setShowRound(roundNumber);
        }
        else if (competitorId !== null) {
            actions.setShowCompetitor(competitorId);
        }
    }, [roundNumber, competitorId]);
    React.useEffect(function () {
        actions.loadEventIfNeeded(eventId);
        actions.loadCompetitionResultIfNeeded(compId);
    }, [eventId, compId]);
    React.useEffect(function () {
        window.scrollTo(0, -1000);
    }, []);
    var showContent = entity != null && !loading && !loadFailure;
    return React.createElement(VBox, null,
        loadingTooLong && React.createElement(LoadingSpinner, null),
        loadFailure && React.createElement(VBox, null,
            React.createElement(HBox, null, "Výsledky soutěže se nepodařilo načíst."),
            React.createElement(HBox, null, "Pokud se jedná o dnešní soutěžní akci, budou výsledky teprve nahrány.")),
        showContent && React.createElement(Content, { eventId: eventId, compId: compId }));
};
export { View as Competition, };
